import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { map, timeout } from "rxjs/operators";

const mainUrl = environment.url;

@Injectable({
  providedIn: "root",
})
export class CurrencyService {
  constructor(private http: HttpClient) {}

  getAllCurrencies(): Observable<any> {
    return this.http.get(mainUrl + "param-currency").pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  checkCurrencyStatus(): Observable<any> {
    return this.http.get(mainUrl + "param-currency/trm/validate").pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  updateCurrencyStatus(body: any): Observable<any> {
    return this.http.post(mainUrl + "param-currency/trm", body).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  createCurrency(form): Observable<any> {
    return this.http.post(mainUrl + "param-currency", form).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getCurrencyById(id): Observable<any> {
    return this.http.get(mainUrl + "param-currency/" + id).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  updateCurrency(id, form): Observable<any> {
    return this.http.put(mainUrl + "param-currency/" + id, form).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  deleteCurrency(id): Observable<any> {
    return this.http.delete(mainUrl + "param-currency/" + id).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getAllTrmsByDay(): Observable<any> {
    return this.http.get(mainUrl + "param-currency/trm-all").pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  setConversionHandbook(data): Observable<any> {
    return this.http.post(mainUrl + "param-currency/trm-set-manually", data).pipe(
      timeout(30000),
      map((res: any) => res.data)
    );
  }

  getHeader() {
    const headers = new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: window.localStorage.getItem("token"),
    });
    return headers;
  }
}
